import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js/max';
import { PhoneNumber } from 'modules/selfServices/types/SelfService';
import { IntlShape } from 'react-intl';

export const validatePhoneNumber = (phoneNumber: string, defaultPrefix: string, intl: IntlShape) => {
  try {
    if (isValidPhoneNumber(`+${phoneNumber}`, { defaultCallingCode: defaultPrefix })) {
      return undefined;
    }
  } catch { /* Nothing to do */ }

  return  intl.formatMessage({
    id: 'error.types.SO_PHONE_NUMBER_NOT_VALID',
    defaultMessage: 'Invalid phone number',
  });
};

const isObject = (value: unknown) => typeof value === 'object' && !Array.isArray(value) && value !== null;

const isPhoneNumberObject = (phoneNumber: PhoneNumber) => isObject(phoneNumber) && String(phoneNumber.prefix) && String(phoneNumber.local);

const formatPhoneNumber = (phoneNumber: PhoneNumber) => {
  if (isPhoneNumberObject(phoneNumber)) {
    return {
      prefix: `+${phoneNumber.prefix.replace(/^\+?(00)?/, '')}`,
      local: phoneNumber.local.replace(/^0/, ''),
    };
  }
  return undefined;
};

export const getCountryByPhoneNumber = (phoneNumber: PhoneNumber) => {
  if (isPhoneNumberObject(phoneNumber)) {
    const { prefix, local } = formatPhoneNumber(phoneNumber);

    try {
      const parsed = parsePhoneNumber(`${prefix}${local}`);
      return parsed?.country;
    } catch { }
  }
  return undefined;
};